import {useTheme, alpha, Skeleton, Typography, Stack, styled} from '@mui/material';
import useLanguage from 'hooks/useLanguage';
import {ActionChip} from './ActionChip';
import {HarvestDemandPutSpeciesEnum} from 'client';
import {useTranslation} from 'react-i18next';

const ActionCardHeader = ({
  site,
  cage,
  date,
  species,
}: {
  site: string;
  cage: string;
  date: Date;
  species?: HarvestDemandPutSpeciesEnum;
}) => {
  const theme = useTheme();
  const secondary = alpha(theme.palette.text.primary, 0.9);
  const variant = 'caption';
  const {dateFormatter} = useLanguage();
  const formattedDate = dateFormatter.toLongDateString(date);
  const {t} = useTranslation('common');
  const speciesTranslated = species ? t(species) : '';

  return (
    <Stack direction="column" width="100%">
      <StyledTypography variant={variant} color={secondary}>
        {site && cage ? site : <Skeleton />}
      </StyledTypography>
      <Stack direction={'row'} alignItems={'center'} spacing={1}>
        <StyledTypography variant={variant} color={secondary}>
          {site && cage ? cage : <Skeleton />}
        </StyledTypography>
        {species && (
          <ActionChip
            title=""
            notUppercase={true}
            value={speciesTranslated}
            backgroundColor={
              species === HarvestDemandPutSpeciesEnum.Salmon ? theme.palette.error.light : theme.palette.success.light
            }
          />
        )}
      </Stack>
      <StyledTypography variant={variant} color={theme.palette.text.disabled}>
        {formattedDate}
      </StyledTypography>
    </Stack>
  );
};

const StyledTypography = styled(Typography)(() => ({
  textTransform: 'uppercase',
}));

export default ActionCardHeader;
